import { render, staticRenderFns } from "./ChatQuickReplySide.vue?vue&type=template&id=39aea167&scoped=true"
import script from "./ChatQuickReplySide.vue?vue&type=script&lang=js"
export * from "./ChatQuickReplySide.vue?vue&type=script&lang=js"
import style0 from "./ChatQuickReplySide.vue?vue&type=style&index=0&id=39aea167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aea167",
  null
  
)

export default component.exports